import { render, staticRenderFns } from "./PricingPremium.vue?vue&type=template&id=724c1750&scoped=true&"
import script from "./PricingPremium.vue?vue&type=script&lang=js&"
export * from "./PricingPremium.vue?vue&type=script&lang=js&"
import style0 from "./PricingPremium.vue?vue&type=style&index=0&id=724c1750&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724c1750",
  null
  
)

export default component.exports